import React from 'react';
import { analytics } from '@sendgrid/bloodhound';
import { Button } from '@sendgrid/ui-components/button';
import Alert from '@sendgrid/ui-components/alert';
import PropTypes from 'prop-types';
import Styles from './resellerLayout.module.scss';
import GcpLogo from './GcpLogo';
import ResellerForm from './ResellerForm';
import FullPageLoader from './FullPageLoader';
import { GoogleSignupEvents } from '../analytics/googleSignupEvents';

export default class ResellerLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldShowSuccessMessage: false,
      createUserError: '',
      isLoading: false,
    };
  }

  showSuccessMessage = () => {
    this.setState({
      shouldShowSuccessMessage: true,
    });
  }

  setCreateUserError = (createUserError) => {
    this.setState({
      createUserError,
    });
  }

  dismissError = () => {
    this.setState({
      createUserError: false,
    });
  }

  setIsLoading = (bool) => {
    this.setState({
      isLoading: bool,
    });
  }

  returnToGoogle = () => {
    analytics.track(GoogleSignupEvents.returnToGoogleClicked());
    window.close();
  }

  render() {
    const successMessage = (
      <div className={Styles['reseller-layout__success-message-container']}>
        <p className={Styles['reseller-layout__success-message']}>
          Congratulations! You have successfully created a Twilio SendGrid account.
        </p>
        <Button
          className={Styles['reseller-layout__return-button']}
          onClick={this.returnToGoogle}
        >
          Return to Google
        </Button>
      </div>
    );

    return (
      <>
        {this.state.createUserError && this.state.createUserError !== '' && (
          <Alert
            type="danger"
            onClick={this.dismissError}
          >
            {this.state.createUserError}
          </Alert>
        )
        }
        {this.state.isLoading && <FullPageLoader />}
        <main className="signup-base-wrapper">
          <section className={`${Styles['reseller-layout']} signup`}>
            <GcpLogo />
            <div>
              {
                this.state.shouldShowSuccessMessage
                  ? successMessage
                  : <ResellerForm showSuccessMessage={this.showSuccessMessage} setIsLoading={this.setIsLoading} setCreateUserError={this.setCreateUserError} location={this.props.location} />
              }
            </div>
          </section>
        </main>
      </>
    );
  }
}

ResellerLayout.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};

ResellerLayout.defaultProps = {
  location: {
    search: '',
  },
};
